import { FastField, Field, type FieldProps } from 'formik';
import type { ComponentType, FC } from 'react';

interface IWithFieldProps {
  memoized?: boolean;
}

export function withField<P extends FieldProps>(Component: ComponentType<P>, isNeverMemoized?: boolean) {
  type OwnProps = Omit<P, keyof FieldProps>;

  const result: FC<OwnProps & IWithFieldProps> = (props: OwnProps & IWithFieldProps) => {
    const { memoized, ...rest } = props;

    const FieldWrapper = isNeverMemoized || !memoized ? Field : FastField;

    return <FieldWrapper {...rest} component={Component} />;
  };

  result.displayName = `withField(${Component.displayName ?? Component.name ?? 'Component'})`;

  return result;
}
